<script lang="ts" module>
  import type { Collection } from '@agapi/mlc-core';
  import type { ActionComponentProps } from '@agapi/ui/utils';

  export interface CollectionGridProps extends ActionComponentProps {
    title?: string;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    collections: Collection[];
  }
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { css } from '@agapi/ui/panda/css';
  import { Section } from '@agapi/ui/section';

  import CollectionCard from './_components/collection-card.svelte';
  import { gridStyles } from './collection-grid.styles';
  import { rewriteUrl } from '../../utils';

  const { collections, use, title, headingLevel = 'h2' }: CollectionGridProps = $props();
</script>

<Section {use}>
  {#if title}
    <svelte:element
      this={headingLevel}
      class={css({ textStyle: 'h3', color: 'text.heading', mb: 5 })}>{title}</svelte:element
    >
  {/if}
  <div class={gridStyles}>
    {#each collections as collection}
      {#if collection?.name && collection?.path}
        <CollectionCard
          title={collection?.name}
          imageUrl={collection?.imageUrl}
          href={rewriteUrl(page, collection?.path ?? '') ?? ''}
        />
      {/if}
    {/each}
  </div>
</Section>
